/**
 * Subpages showcase: tabs switch a full-width scene and its details panel.
 * Auto-advances every 7s while in view, pauses while hovered, and plays a scene's video if it has one.
 */
module.exports = function () {
    document.querySelectorAll('.subpages-showcase').forEach(function (section) {
        const tabs = Array.from(section.querySelectorAll('.tabs button'));
        const DURATION = 7000;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let index = 0, start = 0, elapsed = 0, paused = false, inView = false;

        if (!tabs.length)
            return;

        const show = function (i) {
            index = i;
            const key = tabs[i].dataset.target;

            tabs.forEach(function (tab, n) {
                tab.classList.toggle('is-active', n === i);
                tab.setAttribute('aria-selected', n === i);
                tab.querySelector('.progress').style.width = '0';
            });

            section.querySelectorAll('.scene').forEach(function (scene) {
                const on = scene.dataset.scene === key;
                const video = scene.querySelector('video');

                if (on) {
                    if (scene.classList.contains('is-active'))
                        return;

                    scene.classList.remove('is-leaving');
                    scene.classList.add('is-active');

                    if (video && video.dataset.src) {
                        if (!video.src) {
                            video.src = video.dataset.src;
                            video.onplaying = function () { video.classList.add('is-playing'); };
                        }
                        video.currentTime = 0;
                        video.play().catch(function () {});
                    }
                } else {
                    if (scene.classList.contains('is-active')) {
                        scene.classList.replace('is-active', 'is-leaving');
                        clearTimeout(scene.leaveTimer);
                        scene.leaveTimer = setTimeout(function () { scene.classList.remove('is-leaving'); }, 1300);
                    }

                    if (video)
                        video.pause();
                }
            });

            section.querySelectorAll('.panel').forEach(function (panel) {
                panel.classList.toggle('is-active', panel.dataset.panel === key);
            });

            elapsed = 0;
            start = performance.now();
        };

        const tick = function (now) {
            if (!paused && inView && !reduced && tabs.length > 1) {
                elapsed += now - start;
                tabs[index].querySelector('.progress').style.width = Math.min(elapsed / DURATION * 100, 100) + '%';

                if (elapsed >= DURATION)
                    show((index + 1) % tabs.length);
            }

            start = now;
            requestAnimationFrame(tick);
        };

        tabs.forEach(function (tab, i) {
            tab.addEventListener('mouseenter', function () { if (i !== index) show(i); });
            tab.addEventListener('focus', function () { if (i !== index) show(i); });
            tab.addEventListener('click', function () { show(i); });
        });

        section.addEventListener('mouseenter', function () { paused = true; });
        section.addEventListener('mouseleave', function () { paused = false; });

        new IntersectionObserver(function (entries) {
            inView = entries[0].isIntersecting;
        }, {threshold: .4}).observe(section);

        show(0);
        requestAnimationFrame(tick);
    });
};
